(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const collectionSections = document.querySelectorAll('[data-sc-collection]');

  collectionSections.forEach((section) => {
    const filterOpen = section.querySelector('[data-sc-filter-open]');
    const filterDrawer = section.querySelector('[data-sc-filter-drawer]');
    const filterBackdrop = section.querySelector('.sc-filter-backdrop');
    const filterClosers = section.querySelectorAll('[data-sc-filter-close]');
    const sortControls = section.querySelectorAll('[data-sc-sort]');
    const grid = section.querySelector('[data-sc-products-grid]');
    const pagination = section.querySelector('[data-sc-pagination]');

    const setFiltersOpen = (isOpen) => {
      if (!filterDrawer || !filterBackdrop) return;

      if (isOpen) {
        filterBackdrop.hidden = false;
        filterDrawer.hidden = false;
        document.documentElement.classList.add('sc-filter-lock');

        requestAnimationFrame(() => {
          filterBackdrop.classList.add('is-open');
          filterDrawer.classList.add('is-open');
        });
        return;
      }

      filterBackdrop.classList.remove('is-open');
      filterDrawer.classList.remove('is-open');
      document.documentElement.classList.remove('sc-filter-lock');

      window.setTimeout(() => {
        filterBackdrop.hidden = true;
        filterDrawer.hidden = true;
      }, 320);
    };

    filterOpen?.addEventListener('click', () => setFiltersOpen(true));
    filterClosers.forEach((closer) => {
      closer.addEventListener('click', () => setFiltersOpen(false));
    });

    sortControls.forEach((sort) => {
      const toggle = sort.querySelector('.sc-sort__toggle');
      const options = sort.querySelector('.sc-sort__options');

      toggle?.addEventListener('click', () => {
        if (!options) return;
        const isOpen = options.hidden;
        options.hidden = !isOpen;
        toggle.setAttribute('aria-expanded', String(isOpen));
      });

      sort.querySelectorAll('[data-sort-value]').forEach((option) => {
        option.addEventListener('click', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', option.dataset.sortValue);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });

      sort.querySelectorAll('[data-sort-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });

      document.addEventListener('click', (event) => {
        if (options && !sort.contains(event.target)) {
          options.hidden = true;
          toggle?.setAttribute('aria-expanded', 'false');
        }
      });
    });

    section.querySelectorAll('[data-price-range]').forEach((range) => {
      const minRange = range.querySelector('[data-price-range-min]');
      const maxRange = range.querySelector('[data-price-range-max]');
      const minInput = range.querySelector('[data-price-input-min]');
      const maxInput = range.querySelector('[data-price-input-max]');
      const slider = range.querySelector('.sc-price-range__slider');
      const min = Number(range.dataset.priceMin || 0);
      const max = Number(range.dataset.priceMax || 0);

      if (!minRange || !maxRange || !minInput || !maxInput || !slider || !max) return;

      const clamp = (value) => Math.min(Math.max(Number(value) || 0, min), max);
      const formatValue = (value) => {
        const rounded = Math.round(value * 100) / 100;
        return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
      };

      const updateTrack = () => {
        const minValue = clamp(minRange.value);
        const maxValue = clamp(maxRange.value);
        const minPercent = ((minValue - min) / (max - min)) * 100;
        const maxPercent = ((maxValue - min) / (max - min)) * 100;

        slider.style.setProperty('--range-min', `${minPercent}%`);
        slider.style.setProperty('--range-max', `${maxPercent}%`);
      };

      const syncFromRange = (source) => {
        let minValue = clamp(minRange.value);
        let maxValue = clamp(maxRange.value);

        if (minValue > maxValue) {
          if (source === minRange) {
            maxValue = minValue;
            maxRange.value = maxValue;
          } else {
            minValue = maxValue;
            minRange.value = minValue;
          }
        }

        minInput.value = minValue <= min ? '' : formatValue(minValue);
        maxInput.value = maxValue >= max ? '' : formatValue(maxValue);
        updateTrack();
      };

      const syncFromInput = () => {
        const minValue = minInput.value === '' ? min : clamp(minInput.value);
        const maxValue = maxInput.value === '' ? max : clamp(maxInput.value);
        const nextMin = Math.min(minValue, maxValue);
        const nextMax = Math.max(minValue, maxValue);

        minRange.value = nextMin;
        maxRange.value = nextMax;
        if (minInput.value !== '') minInput.value = formatValue(nextMin);
        if (maxInput.value !== '') maxInput.value = formatValue(nextMax);
        updateTrack();
      };

      minRange.addEventListener('input', () => syncFromRange(minRange));
      maxRange.addEventListener('input', () => syncFromRange(maxRange));
      minInput.addEventListener('input', syncFromInput);
      maxInput.addEventListener('input', syncFromInput);

      syncFromInput();
    });

    let lpgTouchTimer = null;
    let lpgSuppressNextCardClick = false;
    let lpgTouchActiveCard = null;
    let lpgTouchStartX = 0;
    let lpgTouchStartY = 0;

    const clearLpgTouchTimer = () => {
      if (!lpgTouchTimer) return;
      window.clearTimeout(lpgTouchTimer);
      lpgTouchTimer = null;
    };

    const clearLpgTouchCards = (exceptCard = null) => {
      section.querySelectorAll('[data-lpg-product-card].is-touch-active').forEach((touchCard) => {
        if (touchCard !== exceptCard) touchCard.classList.remove('is-touch-active');
      });
    };

    const closeLpgCard = (targetCard) => {
      if (!targetCard) return;

      targetCard.classList.remove('is-quick-open', 'is-notify-open');
      targetCard.classList.remove('is-touch-active');
      targetCard.querySelector('[data-lpg-quick-trigger]')?.setAttribute('aria-expanded', 'false');
      targetCard.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'true');
      targetCard.querySelector('[data-lpg-notify-panel]')?.setAttribute('hidden', '');

      if (targetCard.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    };

    const closeOtherLpgCards = (activeCard) => {
      section.querySelectorAll('[data-lpg-product-card].is-quick-open').forEach((openCard) => {
        if (openCard !== activeCard) closeLpgCard(openCard);
      });
    };

    const setLpgNotifyState = (choiceButton) => {
      const choiceCard = choiceButton?.closest('[data-lpg-product-card]');
      const quickForm = choiceCard?.querySelector('[data-lpg-quick-panel]');
      const add = choiceCard?.querySelector('.lpg-product-card__add-button');
      const selectedSize = choiceCard?.querySelector('[data-lpg-selected-size]');
      const isAvailable = choiceButton?.dataset.available === 'true';
      const variantText = choiceButton?.textContent?.trim() || '';

      if (selectedSize && variantText) selectedSize.textContent = variantText;
      if (quickForm) quickForm.dataset.notifySelected = isAvailable ? 'false' : 'true';
      if (add) {
        add.innerHTML = isAvailable
          ? '<span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--full">Toevoegen aan winkelwagen</span><span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--short">Toevoegen</span>'
          : 'Meld mij aan';
      }
    };

    const openLpgBackInStockModal = (card) => {
      const selectedChoice = card?.querySelector('[data-lpg-variant-choice].is-selected');
      const selectedInput = card?.querySelector('[data-lpg-selected-variant]');
      const variantId = selectedChoice?.dataset.variantId || selectedInput?.value || '';
      const variantTitle = selectedChoice?.dataset.variantTitle || selectedInput?.dataset.variantTitle || card?.querySelector('[data-lpg-selected-size]')?.textContent?.trim() || '';

      window.dispatchEvent(new CustomEvent('wc:back-in-stock:open', {
        detail: {
          productTitle: card?.dataset.productTitle || '',
          productHandle: card?.dataset.productHandle || '',
          variantId,
          variantTitle,
        },
      }));
    };

    const setActiveLpgImage = (card, activeIndex = 0) => {
      const images = card?.querySelectorAll('.lpg-product-card__image');
      if (!images?.length) return;

      const boundedIndex = Math.max(0, Math.min(images.length - 1, activeIndex));
      images.forEach((image, index) => {
        image.classList.toggle('is-active', index === boundedIndex);
      });
    };

    const getActiveLpgImageIndex = (card) => {
      const images = Array.from(card?.querySelectorAll('.lpg-product-card__image') || []);
      if (images.length < 2) return 0;

      const activeIndex = images.findIndex((image) => image.classList.contains('is-active'));
      return activeIndex >= 0 ? activeIndex : 0;
    };

    const handleLpgSwipe = (event) => {
      if (event.pointerType !== 'touch' || !lpgTouchActiveCard) return;

      const deltaX = event.clientX - lpgTouchStartX;
      const deltaY = event.clientY - lpgTouchStartY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);
      const images = lpgTouchActiveCard.querySelectorAll('.lpg-product-card__image');
      if (images.length < 2 || absX < 34 || absX < absY * 1.2) return;

      const currentIndex = getActiveLpgImageIndex(lpgTouchActiveCard);
      const nextIndex = deltaX < 0
        ? Math.min(images.length - 1, currentIndex + 1)
        : Math.max(0, currentIndex - 1);

      setActiveLpgImage(lpgTouchActiveCard, nextIndex);
      lpgSuppressNextCardClick = true;
    };

    section.addEventListener('pointermove', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;

      const mediaLink = event.target.closest('.lpg-product-card__media-link');
      const card = mediaLink?.closest('[data-lpg-product-card]');
      const images = card?.querySelectorAll('.lpg-product-card__image');
      if (!mediaLink || !section.contains(mediaLink) || !card || !images || images.length < 2) return;

      const rect = mediaLink.getBoundingClientRect();
      const ratio = (event.clientX - rect.left) / rect.width;
      const activeIndex = Math.floor(Math.max(0, Math.min(0.999, ratio)) * images.length);
      setActiveLpgImage(card, activeIndex);
    });

    section.addEventListener('pointerout', (event) => {
      const mediaLink = event.target.closest('.lpg-product-card__media-link');
      if (!mediaLink || !section.contains(mediaLink) || mediaLink.contains(event.relatedTarget)) return;

      setActiveLpgImage(mediaLink.closest('[data-lpg-product-card]'), 0);
    });

    section.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'touch') return;

      const card = event.target.closest('[data-lpg-product-card]');
      const interactive = event.target.closest('[data-lpg-quick-trigger], [data-lpg-quick-panel], [data-lpg-notify-panel], [data-wc-wishlist-button]');

      clearLpgTouchTimer();
      if (!card || !section.contains(card) || interactive) return;

      lpgTouchActiveCard = card;
      lpgTouchStartX = event.clientX;
      lpgTouchStartY = event.clientY;
      lpgTouchTimer = window.setTimeout(() => {
        lpgTouchTimer = null;
        clearLpgTouchCards(card);
        card.classList.add('is-touch-active');
        lpgSuppressNextCardClick = true;
      }, 95);
    });

    section.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'touch' || !lpgTouchTimer) return;

      const deltaX = Math.abs(event.clientX - lpgTouchStartX);
      const deltaY = Math.abs(event.clientY - lpgTouchStartY);
      if (deltaX > 8 || deltaY > 8) clearLpgTouchTimer();
    });

    section.addEventListener('pointerup', (event) => {
      handleLpgSwipe(event);
      clearLpgTouchTimer();
    });
    section.addEventListener('pointercancel', clearLpgTouchTimer);

    section.addEventListener('click', (event) => {
      if (lpgSuppressNextCardClick) {
        const lpgCard = event.target.closest('[data-lpg-product-card]');
        const isProductLink = event.target.closest('.lpg-product-card__media-link, .lpg-product-card__caption');

        if (lpgCard && lpgCard === lpgTouchActiveCard && isProductLink) {
          event.preventDefault();
          event.stopPropagation();
        }

        lpgSuppressNextCardClick = false;
        lpgTouchActiveCard = null;
      }

      const lpgTrigger = event.target.closest('[data-lpg-quick-trigger]');
      const lpgClose = event.target.closest('[data-lpg-quick-close]');
      const lpgNotifyClose = event.target.closest('[data-lpg-notify-close]');
      const lpgChoice = event.target.closest('[data-lpg-variant-choice]');
      const lpgAddButton = event.target.closest('.lpg-product-card__add-button');
      const lpgCard = event.target.closest('[data-lpg-product-card]');

      if (lpgTrigger && section.contains(lpgTrigger)) {
        const triggerCard = lpgTrigger.closest('[data-lpg-product-card]');
        if (!triggerCard || lpgTrigger.disabled) return;
        triggerCard.classList.remove('is-touch-active');

        if (lpgTrigger.dataset.lpgDirectAdd === 'true') {
          event.preventDefault();
          triggerCard.querySelector('.lpg-product-card__add-button')?.click();
          return;
        }

        const isOpen = triggerCard.classList.contains('is-quick-open');
        closeOtherLpgCards(triggerCard);

        if (isOpen) {
          closeLpgCard(triggerCard);
        } else {
          triggerCard.classList.add('is-quick-open');
          lpgTrigger.setAttribute('aria-expanded', 'true');
          triggerCard.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'false');
        }

        return;
      }

      if ((lpgClose && section.contains(lpgClose)) || (lpgNotifyClose && section.contains(lpgNotifyClose))) {
        event.preventDefault();
        event.stopPropagation();
        closeLpgCard((lpgClose || lpgNotifyClose).closest('[data-lpg-product-card]'));
        return;
      }

      if (lpgAddButton && section.contains(lpgAddButton)) {
        const addCard = lpgAddButton.closest('[data-lpg-product-card]');
        const quickForm = addCard?.querySelector('[data-lpg-quick-panel]');
        if (quickForm?.dataset.notifySelected === 'true') {
          event.preventDefault();
          event.stopPropagation();
          openLpgBackInStockModal(addCard);
          return;
        }
      }

      if (lpgChoice && section.contains(lpgChoice)) {
        event.preventDefault();

        const choiceCard = lpgChoice.closest('[data-lpg-product-card]');
        const selectedInput = choiceCard?.querySelector('[data-lpg-selected-variant]');

        if (selectedInput) {
          selectedInput.value = lpgChoice.dataset.variantId;
          selectedInput.dataset.variantTitle = lpgChoice.dataset.variantTitle || lpgChoice.textContent.trim();
        }

        choiceCard?.querySelectorAll('[data-lpg-variant-choice]').forEach((button) => {
          button.classList.toggle('is-selected', button === lpgChoice);
        });

        setLpgNotifyState(lpgChoice);
        return;
      }

      if (!lpgCard) {
        closeOtherLpgCards(null);
        clearLpgTouchCards(null);
      }

      const quickToggle = event.target.closest('.sc-product-card__quick-toggle');
      if (!quickToggle || !section.contains(quickToggle)) return;

      quickToggle.closest('.sc-product-card__media')?.classList.toggle('is-quick-open');
    });

    section.querySelectorAll('[data-sc-drag-scroll]').forEach((scroller) => {
      let startX = 0;
      let scrollLeft = 0;
      let dragging = false;

      scroller.addEventListener('pointerdown', (event) => {
        dragging = true;
        startX = event.pageX - scroller.offsetLeft;
        scrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
      });

      scroller.addEventListener('pointerleave', () => {
        dragging = false;
        scroller.classList.remove('is-dragging');
      });

      scroller.addEventListener('pointerup', () => {
        dragging = false;
        scroller.classList.remove('is-dragging');
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        event.preventDefault();
        const x = event.pageX - scroller.offsetLeft;
        scroller.scrollLeft = scrollLeft - (x - startX);
      });
    });

    const updateProgress = () => {
      if (!grid || !pagination) return;

      const total = Number(grid.dataset.totalProducts || 0);
      const shown = grid.querySelectorAll('[data-sc-product-card]').length;
      const rangeEnd = pagination.querySelector('[data-range-end]');
      const totalLabel = pagination.querySelector('[data-total-products-label]');
      const progressBar = pagination.querySelector('[data-progress-bar]');

      if (rangeEnd) rangeEnd.textContent = Math.min(shown, total);
      if (totalLabel) totalLabel.textContent = total;
      if (progressBar && total > 0) {
        progressBar.style.width = `${Math.min((shown / total) * 100, 100).toFixed(2)}%`;
      }
    };

    pagination?.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-next-url]');
      if (!button || button.dataset.loading === 'true') return;

      button.dataset.loading = 'true';
      const originalText = button.textContent;
      button.textContent = 'Cargando...';

      try {
        const response = await fetch(button.dataset.nextUrl);
        if (!response.ok) throw new Error(response.status);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCards = doc.querySelectorAll('[data-sc-products-grid] [data-sc-product-card]');
        const newButton = doc.querySelector('[data-next-url]');

        newCards.forEach((card) => grid.appendChild(card));

        if (newButton) {
          button.dataset.nextUrl = newButton.dataset.nextUrl;
          button.textContent = originalText;
          button.dataset.loading = 'false';
        } else {
          button.remove();
        }

        updateProgress();
        window.dispatchEvent(new CustomEvent('wc:wishlist:refresh'));
      } catch (error) {
        console.error('Error loading more collection products:', error);
        button.textContent = 'Reintentar';
        button.dataset.loading = 'false';
      }
    });

    updateProgress();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-consent"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadCustomerPrivacy = () => new Promise((resolve) => {
      if (window.Shopify?.customerPrivacy) {
        resolve(window.Shopify.customerPrivacy);
        return;
      }

      if (!window.Shopify?.loadFeatures) {
        resolve(null);
        return;
      }

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => resolve(error ? null : window.Shopify?.customerPrivacy || null)
      );
    });

    const getStoredDecision = (banner) => {
      const key = banner.dataset.cookieConsentKey;

      try {
        const storedValue = window.localStorage.getItem(key);
        if (storedValue) return storedValue;
      } catch (error) {
        // Storage can be unavailable in strict privacy contexts.
      }

      const cookieValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${encodeURIComponent(key)}=`))
        ?.split('=')[1];

      return cookieValue ? decodeURIComponent(cookieValue) : null;
    };

    const storeFallbackDecision = (banner, value) => {
      const key = banner.dataset.cookieConsentKey;

      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        // Storage can be unavailable in strict privacy contexts.
      }

      document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; Max-Age=31536000; Path=/; SameSite=Lax`;
    };

    const showBanner = (banner) => {
      banner.hidden = false;
      window.requestAnimationFrame(() => banner.classList.add('is-visible'));
    };

    const hideBanner = (banner) => {
      banner.classList.remove('is-visible');
      window.setTimeout(() => {
        banner.hidden = true;
      }, 440);
    };

    const shouldShowBanner = async (banner, privacyApi) => {
      if (getStoredDecision(banner) === 'set') return false;

      if (privacyApi?.shouldShowBanner) {
        return privacyApi.shouldShowBanner();
      }

      if (privacyApi?.currentVisitorConsent) {
        const consent = privacyApi.currentVisitorConsent();
        return ['preferences', 'analytics', 'marketing'].some((key) => consent?.[key] === '');
      }

      return getStoredDecision(banner) !== 'set';
    };

    const setConsent = async (banner, consent) => {
      storeFallbackDecision(banner, 'set');
      const privacyApi = await loadCustomerPrivacy();

      if (privacyApi?.setTrackingConsent) {
        let callbackDone = false;

        privacyApi.setTrackingConsent(consent, () => {
          callbackDone = true;
          hideBanner(banner);
        });

        window.setTimeout(() => {
          if (!callbackDone) hideBanner(banner);
        }, 1200);
        return;
      }

      hideBanner(banner);
    };

    const initCookieConsent = async (banner) => {
      if (!banner || banner.dataset.cookieConsentReady === 'true') return;
      banner.dataset.cookieConsentReady = 'true';

      const preferences = banner.querySelector('[data-cookie-preferences]');
      const preferencesToggle = banner.querySelector('[data-cookie-preferences-toggle]');
      const saveButton = banner.querySelector('[data-cookie-save]');
      const acceptButton = banner.querySelector('[data-cookie-accept]');
      const essentialButton = banner.querySelector('[data-cookie-essential]');

      preferencesToggle?.addEventListener('click', () => {
        const isOpen = preferences?.hidden === false;
        if (preferences) preferences.hidden = isOpen;
        if (saveButton) saveButton.hidden = isOpen;
        preferencesToggle.setAttribute('aria-expanded', String(!isOpen));
      });

      acceptButton?.addEventListener('click', () => {
        setConsent(banner, {
          preferences: true,
          analytics: true,
          marketing: true,
        });
      });

      essentialButton?.addEventListener('click', () => {
        setConsent(banner, {
          preferences: false,
          analytics: false,
          marketing: false,
        });
      });

      saveButton?.addEventListener('click', () => {
        const consent = {};
        banner.querySelectorAll('[data-cookie-preference]').forEach((input) => {
          consent[input.dataset.cookiePreference] = input.checked;
        });
        setConsent(banner, consent);
      });

      const privacyApi = await loadCustomerPrivacy();
      if (await shouldShowBanner(banner, privacyApi)) {
        showBanner(banner);
      }
    };

    const initAllCookieConsent = () => {
      document.querySelectorAll('[data-cookie-consent]').forEach(initCookieConsent);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCookieConsent);
    } else {
      initAllCookieConsent();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-cookie-consent]').forEach((banner) => {
        banner.dataset.cookieConsentReady = 'false';
        initCookieConsent(banner);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('.footer--mobile-accordions .footer__column--menu .footer__column-title').forEach((heading) => {
    heading.addEventListener('click', () => {
      heading.closest('.footer__column--menu')?.classList.toggle('is-open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const initHeader = (root = document) => {
      root.querySelectorAll('[data-header]').forEach((header) => {
        if (header.dataset.headerInitialized === 'true') return;

        header.dataset.headerInitialized = 'true';

      const desktopDetails = Array.from(header.querySelectorAll('[data-header-details]'));
      const drawer = header.querySelector('[data-header-drawer]');
      const drawerToggle = drawer?.querySelector('.header__mobile-toggle');
      const drawerCloseButtons = Array.from(header.querySelectorAll('[data-header-drawer-close]'));
      const mobileDetails = Array.from(header.querySelectorAll('.header-mobile-menu__details'));
      const sectionWrapper = header.closest('.shopify-section');
      const searchDropdown = header.querySelector('[data-wc-search-dropdown]');
      const searchMenuInput = header.querySelector('[data-wc-search-menu-input]');
      const searchActions = header.querySelector('.header__left-actions');
      const searchOpenButtons = Array.from(header.querySelectorAll('[data-wc-search-open]'));
      const searchCloseButtons = Array.from(header.querySelectorAll('[data-wc-search-close]'));
      const cartDrawer = sectionWrapper?.querySelector('[data-wc-cart-drawer]');
      const cartOpenButtons = Array.from(header.querySelectorAll('[data-wc-cart-open]'));
      const cartCloseButtons = Array.from(cartDrawer?.querySelectorAll('[data-wc-cart-close]') || []);

      if (sectionWrapper && header.classList.contains('header--sticky')) {
        sectionWrapper.style.position = 'sticky';
        sectionWrapper.style.top = getComputedStyle(header).getPropertyValue('--header-sticky-offset') || '0px';
        sectionWrapper.style.zIndex = '30';
      }

      const openSearch = () => {
        if (!searchDropdown) return;

        searchActions?.classList.add('is-search-open');
        searchDropdown.classList.add('is-open');
        searchDropdown.setAttribute('aria-hidden', 'false');
        searchOpenButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
        searchMenuInput?.removeAttribute('tabindex');
        window.setTimeout(() => {
          searchMenuInput?.focus();
        }, 80);
      };

      const closeSearch = () => {
        if (!searchDropdown) return;

        searchActions?.classList.remove('is-search-open');
        searchDropdown.classList.remove('is-open');
        searchDropdown.setAttribute('aria-hidden', 'true');
        searchOpenButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        searchMenuInput?.setAttribute('tabindex', '-1');
      };

      const openCartDrawer = () => {
        if (!cartDrawer) return;

        cartDrawer.classList.add('is-open');
        cartDrawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('wc-cart-drawer-open');
      };

      const closeCartDrawer = () => {
        if (!cartDrawer) return;

        cartDrawer.classList.remove('is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('wc-cart-drawer-open');
      };

      const drawerAnimationDuration = () => {
        const duration = Number.parseInt(getComputedStyle(header).getPropertyValue('--mobile-menu-animation-duration'), 10);
        return Number.isNaN(duration) ? 360 : duration + 160;
      };

      const openMobileDrawer = () => {
        if (!drawer) return;

        window.clearTimeout(drawer._mobileDrawerCloseTimer);
        drawer.classList.remove('is-drawer-closing');
        drawer.setAttribute('open', '');
      };

      const closeMobileDrawer = () => {
        if (!drawer || !drawer.open) return;

        window.clearTimeout(drawer._mobileDrawerCloseTimer);
        drawer.classList.add('is-drawer-closing');

        drawer._mobileDrawerCloseTimer = window.setTimeout(() => {
          drawer.removeAttribute('open');
          drawer.classList.remove('is-drawer-closing');
        }, drawerAnimationDuration());
      };

      const openHeaderDetails = (details) => {
        window.clearTimeout(details._headerHoverCloseTimer);
        window.clearTimeout(details._headerCloseTimer);
        details.classList.remove('is-mega-closing');

        if (!details.open) {
          details.setAttribute('open', '');
        }

        details.classList.add('is-mega-open');
      };

      const closeHeaderDetails = (details) => {
        window.clearTimeout(details._headerHoverCloseTimer);
        window.clearTimeout(details._headerCloseTimer);

        if (!details.open) return;

        details.classList.remove('is-mega-open');
        details.classList.remove('is-mega-closing');
        details.removeAttribute('open');
      };

      const scheduleHeaderDetailsClose = (details) => {
        window.clearTimeout(details._headerHoverCloseTimer);
        closeHeaderDetails(details);
      };

      desktopDetails.forEach((details) => {
        const summary = details.querySelector('summary');
        const panel = details.querySelector('.header-nav__panel');

        summary?.addEventListener('click', (event) => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;

          event.preventDefault();

          if (details.open && details.classList.contains('is-mega-open')) {
            closeHeaderDetails(details);
            return;
          }

          openHeaderDetails(details);

          desktopDetails.forEach((otherDetails) => {
            if (otherDetails !== details) closeHeaderDetails(otherDetails);
          });
        });

        details.addEventListener('toggle', () => {
          if (!details.open) {
            details.classList.remove('is-mega-open', 'is-mega-closing');
            window.clearTimeout(details._headerCloseTimer);
            return;
          }

          openHeaderDetails(details);

          desktopDetails.forEach((otherDetails) => {
            if (otherDetails !== details) closeHeaderDetails(otherDetails);
          });
        });

        details.addEventListener('mouseenter', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;

          openHeaderDetails(details);
        });

        details.addEventListener('mouseleave', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;

          scheduleHeaderDetailsClose(details);
        });

        panel?.addEventListener('mouseenter', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;

          openHeaderDetails(details);
        });

        panel?.addEventListener('mouseleave', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;

          scheduleHeaderDetailsClose(details);
        });
      });

      mobileDetails.forEach((details) => {
        const summary = details.querySelector('summary');

        summary?.addEventListener('click', (event) => {
          if (window.matchMedia('(min-width: 990px)').matches) return;

          event.preventDefault();
          window.clearTimeout(details._mobileCloseTimer);

          if (details.open && !details.classList.contains('is-mobile-closing')) {
            details.classList.add('is-mobile-closing');
            details._mobileCloseTimer = window.setTimeout(() => {
              details.removeAttribute('open');
              details.classList.remove('is-mobile-closing');
            }, Number.parseInt(getComputedStyle(header).getPropertyValue('--mobile-menu-animation-duration'), 10) || 220);
            return;
          }

          details.classList.remove('is-mobile-closing');
          details.setAttribute('open', '');
        });
      });

      drawerToggle?.addEventListener('click', (event) => {
        event.preventDefault();

        if (drawer?.open && !drawer.classList.contains('is-drawer-closing')) {
          closeMobileDrawer();
          return;
        }

        openMobileDrawer();
      });

      drawerCloseButtons.forEach((button) => {
        button.addEventListener('click', () => {
          closeMobileDrawer();
        });
      });

      header.querySelectorAll('.header__drawer-panel a').forEach((link) => {
        link.addEventListener('click', () => {
          closeMobileDrawer();
        });
      });

      searchOpenButtons.forEach((button) => {
        button.addEventListener('click', () => {
          searchDropdown?.classList.contains('is-open') ? closeSearch() : openSearch();
        });
      });

      searchCloseButtons.forEach((button) => {
        button.addEventListener('click', closeSearch);
      });

      cartOpenButtons.forEach((button) => {
        button.addEventListener('click', openCartDrawer);
      });

      cartCloseButtons.forEach((button) => {
        button.addEventListener('click', closeCartDrawer);
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
          desktopDetails.forEach((details) => details.removeAttribute('open'));
          closeSearch();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        desktopDetails.forEach((details) => details.removeAttribute('open'));
        closeMobileDrawer();
        closeSearch();
        closeCartDrawer();
      });
    });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initHeader());
    } else {
      initHeader();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initHeader(event.target);
    });

    if (!window.__wcBackInStockModalBound) {
      window.__wcBackInStockModalBound = true;

      const getBackInStockModal = () => document.querySelector('[data-back-in-stock-modal]');

      const closeBackInStockModal = () => {
        const modal = getBackInStockModal();
        if (!modal) return;

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('wc-back-in-stock-open');
      };

      const openBackInStockModal = (detail = {}) => {
        const modal = getBackInStockModal();
        if (!modal) return;

        const productTitle = detail.productTitle || 'Product';
        const rawVariantTitle = String(detail.variantTitle || '').trim();
        const variantTitle = rawVariantTitle && rawVariantTitle !== 'Default Title' ? rawVariantTitle : '';
        const productHandle = detail.productHandle || '';
        const variantId = detail.variantId || '';
        const productTarget = modal.querySelector('[data-back-in-stock-product]');
        const variantTarget = modal.querySelector('[data-back-in-stock-variant]');
        const tagsInput = modal.querySelector('[data-back-in-stock-modal-tags]');
        const noteInput = modal.querySelector('[data-back-in-stock-modal-note]');
        const emailInput = modal.querySelector('[data-back-in-stock-email]');

        if (productTarget) productTarget.textContent = productTitle;
        if (variantTarget) {
          variantTarget.textContent = variantTitle ? `Maat: ${variantTitle}` : '';
          variantTarget.hidden = !variantTitle;
        }
        if (tagsInput) {
          tagsInput.value = ['back-in-stock', productHandle, variantId ? `variant-${variantId}` : '']
            .filter(Boolean)
            .join(',');
        }
        if (noteInput) {
          noteInput.value = [productTitle, variantTitle ? `Maat: ${variantTitle}` : '', variantId ? `Variant ID: ${variantId}` : '']
            .filter(Boolean)
            .join(' | ');
        }

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('wc-back-in-stock-open');

        window.setTimeout(() => {
          emailInput?.focus();
        }, 80);
      };

      window.addEventListener('wc:back-in-stock:open', (event) => {
        openBackInStockModal(event.detail || {});
      });

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-back-in-stock-close]')) closeBackInStockModal();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeBackInStockModal();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piazza-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const quickToggle = event.target.closest('.lpg-product-grid .sc-product-card__quick-toggle');
    if (!quickToggle) return;

    quickToggle.closest('.sc-product-card__media')?.classList.toggle('is-quick-open');
  });

  let touchTimer = null;
  let suppressNextCardClick = false;
  let touchActiveCard = null;
  let touchStartX = 0;
  let touchStartY = 0;

  const clearTouchTimer = () => {
    if (!touchTimer) return;
    window.clearTimeout(touchTimer);
    touchTimer = null;
  };

  const clearTouchCards = (exceptCard = null) => {
    document.querySelectorAll('[data-lpg-product-card].is-touch-active').forEach((touchCard) => {
      if (touchCard !== exceptCard) touchCard.classList.remove('is-touch-active');
    });
  };

  const setActiveProductCardImage = (card, activeIndex = 0) => {
    const images = card?.querySelectorAll('.lpg-product-card__image');
    if (!images?.length) return;

    const boundedIndex = Math.max(0, Math.min(images.length - 1, activeIndex));
    images.forEach((image, index) => {
      image.classList.toggle('is-active', index === boundedIndex);
    });
  };

  const getActiveProductCardImageIndex = (card) => {
    const images = Array.from(card?.querySelectorAll('.lpg-product-card__image') || []);
    if (images.length < 2) return 0;

    const activeIndex = images.findIndex((image) => image.classList.contains('is-active'));
    return activeIndex >= 0 ? activeIndex : 0;
  };

  const handleProductCardSwipe = (event) => {
    if (event.pointerType !== 'touch' || !touchActiveCard) return;

    const deltaX = event.clientX - touchStartX;
    const deltaY = event.clientY - touchStartY;
    const absX = Math.abs(deltaX);
    const absY = Math.abs(deltaY);
    const images = touchActiveCard.querySelectorAll('.lpg-product-card__image');
    if (images.length < 2 || absX < 34 || absX < absY * 1.2) return;

    const currentIndex = getActiveProductCardImageIndex(touchActiveCard);
    const nextIndex = deltaX < 0
      ? Math.min(images.length - 1, currentIndex + 1)
      : Math.max(0, currentIndex - 1);

    setActiveProductCardImage(touchActiveCard, nextIndex);
    suppressNextCardClick = true;
  };

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;

    const mediaLink = event.target.closest('.lpg-product-card__media-link');
    const card = mediaLink?.closest('[data-lpg-product-card]');
    const images = card?.querySelectorAll('.lpg-product-card__image');
    if (!mediaLink || !card || !images || images.length < 2) return;

    const rect = mediaLink.getBoundingClientRect();
    const ratio = (event.clientX - rect.left) / rect.width;
    const activeIndex = Math.floor(Math.max(0, Math.min(0.999, ratio)) * images.length);
    setActiveProductCardImage(card, activeIndex);
  });

  document.addEventListener('pointerout', (event) => {
    const mediaLink = event.target.closest('.lpg-product-card__media-link');
    if (!mediaLink || mediaLink.contains(event.relatedTarget)) return;

    setActiveProductCardImage(mediaLink.closest('[data-lpg-product-card]'), 0);
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch') return;

    const card = event.target.closest('[data-lpg-product-card]');
    const interactive = event.target.closest('[data-lpg-quick-trigger], [data-lpg-quick-panel], [data-lpg-notify-panel], [data-wc-wishlist-button]');

    clearTouchTimer();
    if (!card || interactive) return;

    touchActiveCard = card;
    touchStartX = event.clientX;
    touchStartY = event.clientY;
    touchTimer = window.setTimeout(() => {
      touchTimer = null;
      clearTouchCards(card);
      card.classList.add('is-touch-active');
      suppressNextCardClick = true;
    }, 95);
  });

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'touch' || !touchTimer) return;

    const deltaX = Math.abs(event.clientX - touchStartX);
    const deltaY = Math.abs(event.clientY - touchStartY);
    if (deltaX > 8 || deltaY > 8) clearTouchTimer();
  });

  document.addEventListener('pointerup', (event) => {
    handleProductCardSwipe(event);
    clearTouchTimer();
  });
  document.addEventListener('pointercancel', clearTouchTimer);

  document.addEventListener('click', (event) => {
    if (!suppressNextCardClick) return;

    const card = event.target.closest('[data-lpg-product-card]');
    const isProductLink = event.target.closest('.lpg-product-card__media-link, .lpg-product-card__caption');

    if (card && card === touchActiveCard && isProductLink) {
      event.preventDefault();
      event.stopPropagation();
    }

    suppressNextCardClick = false;
    touchActiveCard = null;
  }, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lpg-quick-trigger]');
    const close = event.target.closest('[data-lpg-quick-close]');
    const notifyClose = event.target.closest('[data-lpg-notify-close]');
    const choice = event.target.closest('[data-lpg-variant-choice]');
    const addButton = event.target.closest('.lpg-product-card__add-button');
    const card = event.target.closest('[data-lpg-product-card]');

    const closeCard = (targetCard) => {
      if (!targetCard) return;

      targetCard.classList.remove('is-quick-open', 'is-notify-open');
      targetCard.classList.remove('is-touch-active');
      targetCard.querySelector('[data-lpg-quick-trigger]')?.setAttribute('aria-expanded', 'false');
      targetCard.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'true');
      targetCard.querySelector('[data-lpg-notify-panel]')?.setAttribute('hidden', '');

      if (targetCard.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    };

    const closeOtherCards = (activeCard) => {
      document.querySelectorAll('[data-lpg-product-card].is-quick-open').forEach((openCard) => {
        if (openCard !== activeCard) closeCard(openCard);
      });
    };

    const setNotifyState = (choiceButton) => {
      const choiceCard = choiceButton?.closest('[data-lpg-product-card]');
      const quickForm = choiceCard?.querySelector('[data-lpg-quick-panel]');
      const add = choiceCard?.querySelector('.lpg-product-card__add-button');
      const selectedSize = choiceCard?.querySelector('[data-lpg-selected-size]');
      const isAvailable = choiceButton?.dataset.available === 'true';
      const variantText = choiceButton?.textContent?.trim() || '';

      if (selectedSize && variantText) selectedSize.textContent = variantText;
      if (quickForm) quickForm.dataset.notifySelected = isAvailable ? 'false' : 'true';
      if (add) {
        add.innerHTML = isAvailable
          ? '<span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--full">Toevoegen aan winkelwagen</span><span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--short">Toevoegen</span>'
          : 'Meld mij aan';
      }
    };

    const openBackInStockModal = (card) => {
      const selectedChoice = card?.querySelector('[data-lpg-variant-choice].is-selected');
      const selectedInput = card?.querySelector('[data-lpg-selected-variant]');
      const variantId = selectedChoice?.dataset.variantId || selectedInput?.value || '';
      const variantTitle = selectedChoice?.dataset.variantTitle || selectedInput?.dataset.variantTitle || card?.querySelector('[data-lpg-selected-size]')?.textContent?.trim() || '';

      window.dispatchEvent(new CustomEvent('wc:back-in-stock:open', {
        detail: {
          productTitle: card?.dataset.productTitle || '',
          productHandle: card?.dataset.productHandle || '',
          variantId,
          variantTitle,
        },
      }));
    };

    if (trigger) {
      const triggerCard = trigger.closest('[data-lpg-product-card]');
      if (!triggerCard || trigger.disabled) return;
      triggerCard.classList.remove('is-touch-active');

      if (trigger.dataset.lpgDirectAdd === 'true') {
        event.preventDefault();
        triggerCard.querySelector('.lpg-product-card__add-button')?.click();
        return;
      }

      const isOpen = triggerCard.classList.contains('is-quick-open');
      closeOtherCards(triggerCard);

      if (isOpen) {
        closeCard(triggerCard);
      } else {
        triggerCard.classList.add('is-quick-open');
        trigger.setAttribute('aria-expanded', 'true');
        triggerCard.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'false');
      }

      return;
    }

    if (close || notifyClose) {
      event.preventDefault();
      event.stopPropagation();
      closeCard((close || notifyClose).closest('[data-lpg-product-card]'));
      return;
    }

    if (addButton) {
      const addCard = addButton.closest('[data-lpg-product-card]');
      const quickForm = addCard?.querySelector('[data-lpg-quick-panel]');
      if (quickForm?.dataset.notifySelected === 'true') {
        event.preventDefault();
        event.stopPropagation();
        openBackInStockModal(addCard);
        return;
      }
    }

    if (choice) {
      event.preventDefault();

      const choiceCard = choice.closest('[data-lpg-product-card]');
      const selectedInput = choiceCard?.querySelector('[data-lpg-selected-variant]');

      if (selectedInput) {
        selectedInput.value = choice.dataset.variantId;
        selectedInput.dataset.variantTitle = choice.dataset.variantTitle || choice.textContent.trim();
      }

      choiceCard?.querySelectorAll('[data-lpg-variant-choice]').forEach((button) => {
        button.classList.toggle('is-selected', button === choice);
      });

      setNotifyState(choice);

      return;
    }

    if (!card) {
      closeOtherCards(null);
      clearTouchCards(null);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const productData = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const form = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const availability = section.querySelector('[data-product-availability]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const quantityInput = section.querySelector('[data-quantity-input]');
    const payment = section.querySelector('.pd-product-form__payment');
    const backInStockPanel = section.querySelector('[data-back-in-stock-panel]');
    const backInStockCopy = section.querySelector('[data-back-in-stock-copy]');
    const backInStockTags = section.querySelector('[data-back-in-stock-tags]');
    const galleryViewport = section.querySelector('[data-pd-gallery-viewport]');
    const lightbox = section.querySelector('[data-pd-lightbox]');
    const lightboxContent = section.querySelector('[data-pd-lightbox-content]');
    const sizeGuideModal = section.querySelector('[data-size-guide-modal]');
    const tabButtons = section.querySelectorAll('[data-pd-tab-button]');
    const tabPanels = section.querySelectorAll('[data-pd-tab-panel]');

    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);

      return (cents / 100).toLocaleString(document.documentElement.lang || 'nl-NL', {
        style: 'currency',
        currency: productData.currency || 'EUR',
      });
    };

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.pdTabTarget;

        tabButtons.forEach((tab) => {
          const isActive = tab === button;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        tabPanels.forEach((panel) => {
          const isActive = panel.dataset.pdTabPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });

    const selectedOptions = () => {
      return Array.from(section.querySelectorAll('.pd-option')).map((fieldset) => {
        return fieldset.querySelector('[data-option-value]:checked')?.value;
      });
    };

    const findVariant = () => {
      const options = selectedOptions();

      if (!options.length) {
        const currentVariantId = Number(variantInput?.value);
        return productData.variants.find((variant) => Number(variant.id) === currentVariantId)
          || productData.variants.find((variant) => variant.available)
          || productData.variants[0];
      }

      return productData.variants.find((variant) => {
        return variant.options.every((option, index) => option === options[index]);
      });
    };

    const updateOptionAvailability = () => {
      const options = selectedOptions();

      section.querySelectorAll('.pd-option').forEach((fieldset) => {
        const optionIndex = Number(fieldset.dataset.optionIndex);
        const isSizeOption = fieldset.classList.contains('pd-option--size');

        fieldset.querySelectorAll('[data-option-value]').forEach((input) => {
          if (!isSizeOption) {
            input.disabled = false;
            return;
          }

          const label = section.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          const hasAvailableVariant = productData.variants.some((variant) => {
            if (variant.options[optionIndex] !== input.value || !variant.available) return false;

            return variant.options.every((optionValue, index) => {
              return index === optionIndex || !options[index] || optionValue === options[index];
            });
          });

          input.disabled = false;
          input.dataset.available = hasAvailableVariant ? 'true' : 'false';
          label?.classList.toggle('is-unavailable', !hasAvailableVariant);
        });
      });
    };

    const setBackInStockPanel = (variant) => {
      const isSoldOut = Boolean(variant && !variant.available);
      if (backInStockPanel) backInStockPanel.hidden = true;
      if (payment) payment.hidden = isSoldOut;
      if (form) form.dataset.backInStock = isSoldOut ? 'true' : 'false';

      if (isSoldOut && variant) {
        if (backInStockCopy) {
          backInStockCopy.textContent = `${variant.title} is tijdelijk uitverkocht. Laat je e-mailadres achter, dan krijg je bericht wanneer deze maat weer op voorraad is.`;
        }
        if (backInStockTags) {
          backInStockTags.value = `back-in-stock,${productData.handle},variant-${variant.id}`;
        }
      }
    };

    const openProductBackInStockModal = (variant) => {
      if (!variant) return;

      window.dispatchEvent(new CustomEvent('wc:back-in-stock:open', {
        detail: {
          productTitle: productData.title || '',
          productHandle: productData.handle || '',
          variantId: variant.id || '',
          variantTitle: variant.title || '',
        },
      }));
    };

    const updateActiveMedia = (index) => {
      section.querySelectorAll('[data-pd-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.pdThumb === String(index));
      });
      section.querySelectorAll('[data-pd-dot]').forEach((dot) => {
        dot.classList.toggle('is-active', dot.dataset.pdDot === String(index));
      });
    };

    const updateVariant = () => {
      updateOptionAvailability();
      const variant = findVariant();

      section.querySelectorAll('.pd-option').forEach((fieldset) => {
        const selected = fieldset.querySelector('[data-option-value]:checked');
        const label = fieldset.querySelector('[data-selected-option]');
        if (selected && label) label.textContent = selected.value;
      });

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Niet beschikbaar';
          addButton.classList.remove('is-back-in-stock');
        }
        setBackInStockPanel(null);
        if (availability) {
          availability.textContent = 'Niet beschikbaar';
          availability.classList.add('is-sold-out');
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      const priceMarkup = [];
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceMarkup.push(`<s>${formatMoney(variant.compare_at_price)}</s>`);
      }
      priceMarkup.push(`<span>${formatMoney(variant.price)}</span>`);
      if (price) price.innerHTML = priceMarkup.join('');

      if (variant.available) {
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = 'In winkelwagen';
          addButton.classList.remove('is-back-in-stock');
        }
        setBackInStockPanel(null);
        if (availability) {
          availability.textContent = 'Op voorraad';
          availability.classList.remove('is-sold-out');
        }
      } else {
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = 'Meld mij aan';
          addButton.classList.add('is-back-in-stock');
        }
        setBackInStockPanel(variant);
        if (availability) {
          availability.textContent = 'Uitverkocht';
          availability.classList.add('is-sold-out');
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    section.querySelector('[data-pd-back]')?.addEventListener('click', () => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/collections/all';
      }
    });

    form?.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-value]')) updateVariant();
    });

    form?.addEventListener('submit', (event) => {
      if (form.dataset.backInStock !== 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const variant = findVariant();
      openProductBackInStockModal(variant);
    }, true);

    updateVariant();

    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(Number(quantityInput.value || 1) - 1, 1);
    });

    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Number(quantityInput.value || 1) + 1;
    });

    section.querySelectorAll('[data-pd-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = button.dataset.pdThumb;
        const item = section.querySelector(`[data-pd-media="${index}"]`);
        updateActiveMedia(index);
        item?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });

    if (galleryViewport && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible?.target?.dataset.pdMedia) updateActiveMedia(visible.target.dataset.pdMedia);
      }, {
        root: galleryViewport,
        threshold: [0.55, 0.75],
      });

      section.querySelectorAll('[data-pd-media]').forEach((item) => observer.observe(item));
    }

    const hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const resetZoom = (frame) => {
      frame.classList.remove('is-zoomed');
      frame.style.setProperty('--pd-zoom-x', '50%');
      frame.style.setProperty('--pd-zoom-y', '50%');
    };
    const setZoomPosition = (frame, event) => {
      const rect = frame.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      frame.style.setProperty('--pd-zoom-x', `${x}%`);
      frame.style.setProperty('--pd-zoom-y', `${y}%`);
    };

    section.querySelectorAll('[data-pd-zoom-frame]').forEach((frame) => {
      let pointerStart = null;

      if (hasFinePointer) {
        frame.addEventListener('pointerenter', (event) => {
          frame.classList.add('is-zoomed');
          setZoomPosition(frame, event);
        });
        frame.addEventListener('pointermove', (event) => {
          if (frame.classList.contains('is-zoomed')) setZoomPosition(frame, event);
        });
        frame.addEventListener('pointerleave', () => resetZoom(frame));
        return;
      }

      frame.addEventListener('pointerdown', (event) => {
        pointerStart = { x: event.clientX, y: event.clientY };
      });

      frame.addEventListener('pointermove', (event) => {
        if (frame.classList.contains('is-zoomed')) setZoomPosition(frame, event);
      });

      frame.addEventListener('click', (event) => {
        const moved = pointerStart
          ? Math.abs(event.clientX - pointerStart.x) > 8 || Math.abs(event.clientY - pointerStart.y) > 8
          : false;
        pointerStart = null;
        if (moved) return;

        event.preventDefault();
        if (frame.classList.contains('is-zoomed')) {
          resetZoom(frame);
        } else {
          section.querySelectorAll('[data-pd-zoom-frame].is-zoomed').forEach(resetZoom);
          frame.classList.add('is-zoomed');
          setZoomPosition(frame, event);
        }
      });
    });

    section.querySelector('[data-pd-lightbox-close]')?.addEventListener('click', () => {
      lightbox?.close();
    });

    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });

    section.querySelectorAll('[data-size-guide-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!sizeGuideModal) return;

        if (typeof sizeGuideModal.showModal === 'function') {
          sizeGuideModal.showModal();
        } else {
          sizeGuideModal.setAttribute('open', '');
        }
      });
    });

    section.querySelector('[data-size-guide-close]')?.addEventListener('click', () => {
      sizeGuideModal?.close();
    });

    sizeGuideModal?.addEventListener('click', (event) => {
      if (event.target === sizeGuideModal) sizeGuideModal.close();
    });
  });

  if (!window.__pdRelatedCardsBound) {
    window.__pdRelatedCardsBound = true;

    let relatedTouchTimer = null;
    let relatedSuppressNextCardClick = false;
    let relatedTouchActiveCard = null;
    let relatedTouchStartX = 0;
    let relatedTouchStartY = 0;

    const clearRelatedTouchTimer = () => {
      if (!relatedTouchTimer) return;
      window.clearTimeout(relatedTouchTimer);
      relatedTouchTimer = null;
    };

    const clearRelatedTouchCards = (exceptCard = null) => {
      document.querySelectorAll('.pd-related [data-lpg-product-card].is-touch-active').forEach((card) => {
        if (card !== exceptCard) card.classList.remove('is-touch-active');
      });
    };

    const setActiveRelatedCardImage = (card, activeIndex = 0) => {
      const images = card?.querySelectorAll('.lpg-product-card__image');
      if (!images?.length) return;

      const boundedIndex = Math.max(0, Math.min(images.length - 1, activeIndex));
      images.forEach((image, index) => {
        image.classList.toggle('is-active', index === boundedIndex);
      });
    };

    const getActiveRelatedCardImageIndex = (card) => {
      const images = Array.from(card?.querySelectorAll('.lpg-product-card__image') || []);
      if (images.length < 2) return 0;

      const activeIndex = images.findIndex((image) => image.classList.contains('is-active'));
      return activeIndex >= 0 ? activeIndex : 0;
    };

    const closeRelatedCard = (card) => {
      if (!card) return;

      card.classList.remove('is-quick-open', 'is-notify-open', 'is-touch-active');
      card.querySelector('[data-lpg-quick-trigger]')?.setAttribute('aria-expanded', 'false');
      card.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'true');
      card.querySelector('[data-lpg-notify-panel]')?.setAttribute('hidden', '');

      if (card.contains(document.activeElement)) document.activeElement.blur();
    };

    const closeOtherRelatedCards = (activeCard) => {
      document.querySelectorAll('.pd-related [data-lpg-product-card].is-quick-open').forEach((card) => {
        if (card !== activeCard) closeRelatedCard(card);
      });
    };

    const setRelatedNotifyState = (choiceButton) => {
      const choiceCard = choiceButton?.closest('[data-lpg-product-card]');
      const quickForm = choiceCard?.querySelector('[data-lpg-quick-panel]');
      const add = choiceCard?.querySelector('.lpg-product-card__add-button');
      const selectedSize = choiceCard?.querySelector('[data-lpg-selected-size]');
      const isAvailable = choiceButton?.dataset.available === 'true';
      const variantText = choiceButton?.textContent?.trim() || '';

      if (selectedSize && variantText) selectedSize.textContent = variantText;
      if (quickForm) quickForm.dataset.notifySelected = isAvailable ? 'false' : 'true';
      if (add) {
        add.innerHTML = isAvailable
          ? '<span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--full">Toevoegen aan winkelwagen</span><span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--short">Toevoegen</span>'
          : 'Meld mij aan';
      }
    };

    const openRelatedBackInStockModal = (card) => {
      const selectedChoice = card?.querySelector('[data-lpg-variant-choice].is-selected');
      const selectedInput = card?.querySelector('[data-lpg-selected-variant]');
      const variantId = selectedChoice?.dataset.variantId || selectedInput?.value || '';
      const variantTitle = selectedChoice?.dataset.variantTitle || selectedInput?.dataset.variantTitle || card?.querySelector('[data-lpg-selected-size]')?.textContent?.trim() || '';

      window.dispatchEvent(new CustomEvent('wc:back-in-stock:open', {
        detail: {
          productTitle: card?.dataset.productTitle || '',
          productHandle: card?.dataset.productHandle || '',
          variantId,
          variantTitle,
        },
      }));
    };

    document.addEventListener('click', (event) => {
      const prev = event.target.closest('[data-pd-related-prev]');
      const next = event.target.closest('[data-pd-related-next]');
      const control = prev || next;
      if (!control) return;

      const related = control.closest('[data-pd-related]');
      const scroller = related?.querySelector('.pd-related__scroller');
      const firstCard = scroller?.querySelector('.lpg-product-card');
      if (!scroller || !firstCard) return;

      const gap = Number.parseFloat(window.getComputedStyle(scroller).columnGap || '0');
      const step = (firstCard.getBoundingClientRect().width + gap) * 2;
      scroller.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
    });

    document.addEventListener('pointermove', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;

      const mediaLink = event.target.closest('.pd-related .lpg-product-card__media-link');
      const card = mediaLink?.closest('[data-lpg-product-card]');
      const images = card?.querySelectorAll('.lpg-product-card__image');
      if (!mediaLink || !card || !images || images.length < 2) return;

      const rect = mediaLink.getBoundingClientRect();
      const ratio = (event.clientX - rect.left) / rect.width;
      const activeIndex = Math.floor(Math.max(0, Math.min(0.999, ratio)) * images.length);
      setActiveRelatedCardImage(card, activeIndex);
    });

    document.addEventListener('pointerout', (event) => {
      const mediaLink = event.target.closest('.pd-related .lpg-product-card__media-link');
      if (!mediaLink || mediaLink.contains(event.relatedTarget)) return;

      setActiveRelatedCardImage(mediaLink.closest('[data-lpg-product-card]'), 0);
    });

    document.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'touch') return;

      const card = event.target.closest('.pd-related [data-lpg-product-card]');
      const interactive = event.target.closest('[data-lpg-quick-trigger], [data-lpg-quick-panel], [data-lpg-notify-panel], [data-wc-wishlist-button]');

      clearRelatedTouchTimer();
      if (!card || interactive) return;

      relatedTouchActiveCard = card;
      relatedTouchStartX = event.clientX;
      relatedTouchStartY = event.clientY;
      relatedTouchTimer = window.setTimeout(() => {
        relatedTouchTimer = null;
        clearRelatedTouchCards(card);
        card.classList.add('is-touch-active');
        relatedSuppressNextCardClick = true;
      }, 95);
    });

    document.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'touch' || !relatedTouchTimer) return;

      const deltaX = Math.abs(event.clientX - relatedTouchStartX);
      const deltaY = Math.abs(event.clientY - relatedTouchStartY);
      if (deltaX > 8 || deltaY > 8) clearRelatedTouchTimer();
    });

    document.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'touch' && relatedTouchActiveCard) {
        const deltaX = event.clientX - relatedTouchStartX;
        const deltaY = event.clientY - relatedTouchStartY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        const images = relatedTouchActiveCard.querySelectorAll('.lpg-product-card__image');

        if (images.length > 1 && absX >= 34 && absX >= absY * 1.2) {
          const currentIndex = getActiveRelatedCardImageIndex(relatedTouchActiveCard);
          const nextIndex = deltaX < 0
            ? Math.min(images.length - 1, currentIndex + 1)
            : Math.max(0, currentIndex - 1);

          setActiveRelatedCardImage(relatedTouchActiveCard, nextIndex);
          relatedSuppressNextCardClick = true;
        }
      }

      clearRelatedTouchTimer();
    });

    document.addEventListener('pointercancel', clearRelatedTouchTimer);

    document.addEventListener('click', (event) => {
      if (!relatedSuppressNextCardClick) return;

      const card = event.target.closest('.pd-related [data-lpg-product-card]');
      const isProductLink = event.target.closest('.lpg-product-card__media-link, .lpg-product-card__caption');

      if (card && card === relatedTouchActiveCard && isProductLink) {
        event.preventDefault();
        event.stopPropagation();
      }

      relatedSuppressNextCardClick = false;
      relatedTouchActiveCard = null;
    }, true);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.pd-related [data-lpg-quick-trigger]');
      const close = event.target.closest('.pd-related [data-lpg-quick-close]');
      const notifyClose = event.target.closest('.pd-related [data-lpg-notify-close]');
      const choice = event.target.closest('.pd-related [data-lpg-variant-choice]');
      const addButton = event.target.closest('.pd-related .lpg-product-card__add-button');
      const card = event.target.closest('.pd-related [data-lpg-product-card]');

      if (trigger) {
        const triggerCard = trigger.closest('[data-lpg-product-card]');
        if (!triggerCard || trigger.disabled) return;
        triggerCard.classList.remove('is-touch-active');

        if (trigger.dataset.lpgDirectAdd === 'true') {
          event.preventDefault();
          triggerCard.querySelector('.lpg-product-card__add-button')?.click();
          return;
        }

        const isOpen = triggerCard.classList.contains('is-quick-open');
        closeOtherRelatedCards(triggerCard);

        if (isOpen) {
          closeRelatedCard(triggerCard);
        } else {
          triggerCard.classList.add('is-quick-open');
          trigger.setAttribute('aria-expanded', 'true');
          triggerCard.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'false');
        }

        return;
      }

      if (close || notifyClose) {
        event.preventDefault();
        event.stopPropagation();
        closeRelatedCard((close || notifyClose).closest('[data-lpg-product-card]'));
        return;
      }

      if (addButton) {
        const addCard = addButton.closest('[data-lpg-product-card]');
        const quickForm = addCard?.querySelector('[data-lpg-quick-panel]');
        if (quickForm?.dataset.notifySelected === 'true') {
          event.preventDefault();
          event.stopPropagation();
          openRelatedBackInStockModal(addCard);
          return;
        }
      }

      if (choice) {
        event.preventDefault();

        const choiceCard = choice.closest('[data-lpg-product-card]');
        const selectedInput = choiceCard?.querySelector('[data-lpg-selected-variant]');

        if (selectedInput) selectedInput.value = choice.dataset.variantId;
        if (selectedInput) selectedInput.dataset.variantTitle = choice.dataset.variantTitle || choice.textContent.trim();

        choiceCard?.querySelectorAll('[data-lpg-variant-choice]').forEach((button) => {
          button.classList.toggle('is-selected', button === choice);
        });

        setRelatedNotifyState(choice);

        return;
      }

      if (!card) {
        closeOtherRelatedCards(null);
        clearRelatedTouchCards(null);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('[data-sc-search]').forEach((section) => {
    const setActiveImage = (card, imageIndex) => {
      const images = card?.querySelectorAll('.lpg-product-card__image');
      if (!images?.length) return;

      const safeIndex = Math.max(0, Math.min(imageIndex, images.length - 1));
      images.forEach((image, index) => image.classList.toggle('is-active', index === safeIndex));
    };

    const closeCard = (card) => {
      if (!card) return;
      card.classList.remove('is-quick-open', 'is-touch-active');
      card.querySelector('[data-lpg-quick-trigger]')?.setAttribute('aria-expanded', 'false');
      card.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'true');
    };

    const closeOtherCards = (card) => {
      section.querySelectorAll('[data-lpg-product-card].is-quick-open').forEach((openCard) => {
        if (openCard !== card) closeCard(openCard);
      });
    };

    section.addEventListener('pointermove', (event) => {
      if (window.matchMedia('(max-width: 749px)').matches) return;

      const mediaLink = event.target.closest('.lpg-product-card__media-link');
      const card = mediaLink?.closest('[data-lpg-product-card]');
      const images = card?.querySelectorAll('.lpg-product-card__image');
      if (!mediaLink || !card || !images || images.length <= 1) return;

      const rect = mediaLink.getBoundingClientRect();
      const progress = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 0.999);
      setActiveImage(card, Math.floor(progress * images.length));
    });

    section.addEventListener('pointerout', (event) => {
      if (window.matchMedia('(max-width: 749px)').matches) return;

      const mediaLink = event.target.closest('.lpg-product-card__media-link');
      if (!mediaLink || mediaLink.contains(event.relatedTarget)) return;
      setActiveImage(mediaLink.closest('[data-lpg-product-card]'), 0);
    });

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-lpg-quick-trigger]');
      const close = event.target.closest('[data-lpg-quick-close]');
      const choice = event.target.closest('[data-lpg-variant-choice]');
      const addButton = event.target.closest('.lpg-product-card__add-button');

      if (trigger) {
        const card = trigger.closest('[data-lpg-product-card]');
        if (!card) return;

        if (trigger.dataset.lpgDirectAdd === 'true') {
          card.querySelector('.lpg-product-card__add-button')?.click();
          return;
        }

        const isOpen = card.classList.contains('is-quick-open');
        closeOtherCards(card);
        card.classList.toggle('is-quick-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
        card.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', String(isOpen));
      }

      if (close) {
        closeCard(close.closest('[data-lpg-product-card]'));
      }

      if (choice) {
        const card = choice.closest('[data-lpg-product-card]');
        const quickForm = card?.querySelector('[data-lpg-quick-panel]');
        const selectedInput = quickForm?.querySelector('[data-lpg-selected-variant]');
        const selectedSize = quickForm?.querySelector('[data-lpg-selected-size]');
        const add = quickForm?.querySelector('.lpg-product-card__add-button');

        if (!card || !quickForm || !selectedInput || !add) return;

        quickForm.querySelectorAll('[data-lpg-variant-choice]').forEach((button) => {
          button.classList.toggle('is-selected', button === choice);
        });

        selectedInput.value = choice.dataset.variantId;
        selectedInput.dataset.variantTitle = choice.dataset.variantTitle || '';
        if (selectedSize) selectedSize.textContent = choice.dataset.variantTitle || '';

        if (choice.dataset.available === 'true') {
          quickForm.dataset.notifySelected = 'false';
          add.innerHTML = '<span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--full">Toevoegen aan winkelwagen</span><span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--short">Toevoegen</span>';
        } else {
          quickForm.dataset.notifySelected = 'true';
          add.textContent = 'Meld mij aan';
        }
      }

      if (addButton) {
        const card = addButton.closest('[data-lpg-product-card]');
        const quickForm = card?.querySelector('[data-lpg-quick-panel]');
        if (quickForm?.dataset.notifySelected === 'true') {
          event.preventDefault();
          alert('Laat je e-mailadres achter op de productpagina om bericht te krijgen wanneer deze maat weer op voorraad is.');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
